import React, {
  Fragment,
  useState,
  useEffect,
  useContext,
  useRef,
} from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import { styled, alpha } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Toolbox from "../common/Toolbox";
import SlidingDrawer from "../common/SlidingDrawer";
import CustomDialog from "../common/CustomDialog";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { TextField, InputAdornment } from "@mui/material";
import { useResponsive } from "../hooks/useResponsive";
import _ from "lodash";
// import customers from "../../data/customers.json";
import { MultiSelect } from "primereact/multiselect";
import { Dialog } from "primereact/dialog";
import { FilterMatchMode, FilterOperator, FilterService } from "primereact/api";
import AuthContext from "../../context/auth/AuthContext";
import CustomerContext from "../../context/customer/CustomerContext";
import FilingMasterContext from "../../context/filing-master/FilingMasterContext";
import CustomerComments from "./CustomerComments";
import ClientProfileHistory from "./ClientProfileHistory";
import axios from "axios";
import CustomerBusinessCategory from "./CustomerBusinessCategory";
import ReactLoading from "react-loading";
import usePermission from "../../usePermission";
import { useCommonDetailsContext } from "../../context/Common/common";
import IconButton from "@mui/material/IconButton";
import states from "../../data/StateLookup.json";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { OverlayPanel } from "primereact/overlaypanel";
import { Dropdown } from "primereact/dropdown";
import { Box } from "@mui/material";
import { TrackNowButton } from "../ui";
import { tokens } from "../../theme/tokens";
import ClientTableFilter from "./ClientTableFilter";
import { GoogleMaterialIcon } from "../ui/GoogleMaterialIcon";
import "./ClientProfiles.scss";
import SvgIcon from "@mui/material/SvgIcon";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import { Chip } from "@mui/material";
import { Stack } from "@mui/material";
// Table-specific compact button component
const OrganizationArrow = () => (
  <SvgIcon
    sx={{
      fontSize: 20,
      color: "#483568",
    }}
    viewBox="0 -960 960 960"
  >
    <path d="M480-80 200-360l56-57 184 184v-287h80v287l184-183 56 56L480-80Zm-40-520v-120h80v120h-80Zm0-200v-80h80v80h-80Z" />
  </SvgIcon>
);
const OrganizationTreeIcon = ({ color = "#1f1f1f", size = 20 }) => (
  <SvgIcon
    viewBox="0 -960 960 960"
    sx={{
      fontSize: size,
      color,
    }}
  >
    <path d="M600-120v-120H440v-400h-80v120H80v-320h280v120h240v-120h280v320H600v-120h-80v320h80v-120h280v320H600ZM160-760v160-160Zm520 400v160-160Zm0-400v160-160Zm0 160h120v-160H680v160Zm0 400h120v-160H680v160ZM160-600h120v-160H160v160Z" />
  </SvgIcon>
);
const TableCompactButton = ({ children, onClick, style = {} }) => {
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const handleMouseEnter = (e) => {
    e.currentTarget.style.fontWeight = '600';
    // Apply to all child elements
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '600';
      }
    });
  };

  const handleMouseLeave = (e) => {
    e.currentTarget.style.fontWeight = '400';
    // Apply to all child elements
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '400';
      }
    });
  };

  const handleMouseDown = (e) => {
    e.currentTarget.style.fontWeight = '700';
    // Apply to all child elements
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '700';
      }
    });
  };

  const handleMouseUp = (e) => {

    e.currentTarget.style.fontWeight = '600';
    // Apply to all child elements
    const childDivs = e.currentTarget.querySelectorAll('div');
    childDivs.forEach(div => {
      if (!div.style.fontSize || div.style.fontSize !== '12px') {
        div.style.fontWeight = '600';
      }
    });
  };

  return (
    <button
      onClick={onClick}
      style={{
        backgroundColor: 'transparent',
        border: 'none',
        color: primaryColor,
        cursor: 'pointer',
        fontSize: '14px',
        fontWeight: 400,
        padding: '4px 8px',
        borderRadius: '4px',
        textAlign: 'left',
        width: '100%',
        transition: 'font-weight 0.2s ease',
        ...style
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
    >
      {children}
    </button>
  );
};

const MULTI_VALUE_CONTAINS_MATCH_MODE = "customMultiValueContains";
const MULTI_VALUE_NOT_CONTAINS_MATCH_MODE = "customMultiValueNotContains";
const MULTI_VALUE_EQUALS_MATCH_MODE = "customMultiValueEquals";
const MULTI_VALUE_FILTER_FIELDS = ["categories", "programLists", "stateList"];

const splitCommaSeparatedValues = (value) => {
  if (Array.isArray(value)) {
    return value
      .flatMap((item) =>
        typeof item === "string" ? item.split(",") : [item]
      )
      .map((item) => String(item).trim())
      .filter(Boolean);
  }

  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  if (value === null || value === undefined || value === "") {
    return [];
  }

  return [String(value).trim()].filter(Boolean);
};

const normalizeMultiValueFilterTokens = (value) =>
  splitCommaSeparatedValues(value).map((item) => item.toLowerCase());

const getClientProfileTableMatchMode = (field, matchMode) => {
  if (!MULTI_VALUE_FILTER_FIELDS.includes(field)) {
    return matchMode;
  }

  if (matchMode === FilterMatchMode.IN) {
    return MULTI_VALUE_CONTAINS_MATCH_MODE;
  }

  if (matchMode === FilterMatchMode.NOT_CONTAINS) {
    return MULTI_VALUE_NOT_CONTAINS_MATCH_MODE;
  }

  if (matchMode === FilterMatchMode.EQUALS) {
    return MULTI_VALUE_EQUALS_MATCH_MODE;
  }

  return matchMode;
};

const normalizeClientProfileMatchMode = (matchMode) => {
  if (matchMode === MULTI_VALUE_CONTAINS_MATCH_MODE) {
    return FilterMatchMode.IN;
  }

  if (matchMode === MULTI_VALUE_NOT_CONTAINS_MATCH_MODE) {
    return FilterMatchMode.NOT_CONTAINS;
  }

  if (matchMode === MULTI_VALUE_EQUALS_MATCH_MODE) {
    return FilterMatchMode.EQUALS;
  }

  return matchMode;
};

let hasRegisteredClientProfileFilters = false;

if (!hasRegisteredClientProfileFilters) {
  FilterService.register(MULTI_VALUE_CONTAINS_MATCH_MODE, (value, filter) => {
    const cellTokens = normalizeMultiValueFilterTokens(value);
    const filterTokens = normalizeMultiValueFilterTokens(filter);

    if (filterTokens.length === 0) {
      return true;
    }

    if (cellTokens.length === 0) {
      return false;
    }

    return filterTokens.some((token) => cellTokens.includes(token));
  });

  FilterService.register(
    MULTI_VALUE_NOT_CONTAINS_MATCH_MODE,
    (value, filter) => {
      const cellTokens = normalizeMultiValueFilterTokens(value);
      const filterTokens = normalizeMultiValueFilterTokens(filter);

      if (filterTokens.length === 0) {
        return true;
      }

      if (cellTokens.length === 0) {
        return true;
      }

      return filterTokens.every((token) => !cellTokens.includes(token));
    }
  );

  FilterService.register(MULTI_VALUE_EQUALS_MATCH_MODE, (value, filter) => {
    const cellTokens = normalizeMultiValueFilterTokens(value).sort();
    const filterTokens = normalizeMultiValueFilterTokens(filter).sort();

    if (filterTokens.length === 0) {
      return true;
    }

    if (cellTokens.length !== filterTokens.length) {
      return false;
    }

    return cellTokens.every((token, index) => token === filterTokens[index]);
  });

  hasRegisteredClientProfileFilters = true;
}

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));

const ClientProfiles = () => {
  const API_BASE_URL = process.env.REACT_APP_TRKNW_API_BASE_URL;
  const { publishedBranding } = useCommonDetailsContext();
  const primaryColor = publishedBranding?.primaryColor || tokens.colors.connectedPurple;
  const { isMobile, mdUp } = useResponsive();
  const enableForzen = !isMobile
  const navigate = useNavigate();
  const filingMasterContext = useContext(FilingMasterContext);
  const authContext = useContext(AuthContext);
  const { roleType, authUser, authId } = authContext;
  const customerContext = useContext(CustomerContext);
  const {
    getCustomers,
    customers,
    customerLoaded,
    setCurrentCustomer,
    deleteCustomer,
    getCustomerComments,
    getCustomerBusinessCategories,
  } = customerContext;
  const { getBusinessCategories, getProgramName } = filingMasterContext;
  // const data = customers;
  // const [visibleApps, setVisibleApps] = useState(props.projects);
  const [comments, setComments] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [categoriesLookup, setCategoriesLookup] = React.useState([]);
  const [programList, setProgramList] = React.useState([]);
  const [federalFilterSelectedValues, setFederalFilterSelectedValues] =
    React.useState([]);
  const [programNamesSelectedValues, setProgramNamesSelectedValues] =
    React.useState([]);
  const [filterState, setFilterState] = React.useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [showCategories, setShowCategories] = useState(false);
  const [clients, setClients] = useState([]);
  const [selectedClients, setSelectedClients] = useState(null);
  const [selectedClientId, setSelectedClientId] = useState(null);
  const [rowClick, setRowClick] = useState(true);
  const [radioMessage, setRadioMessage] = useState("Which Defered Filing you want to open");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertConfig, setAlertConfig] = useState({
    header: "Information",
    icon: "\u2139\uFE0F",
  });
  const [showRadio, setShowRadio] = useState(false);
  const [radioVal, setRadioVal] = React.useState('tracknow');
  const [isLoading, setIsLoading] = useState(true);
  const [viewAll, setViewAll] = useState(true);
  const [stateList, setStateList] = useState([]);
  const [isClearIcon, setIsClearIcon] = useState(false);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [activeFilters, setActiveFilters] = useState([]);
  const [lazyLoading, setLazyLoading] = useState(false);
  const [refreshRecordList, setRefreshRecordList] = useState(false);
  const [refreshDetails, setRefreshDetails] = useState(null);
  const [recordsInView, setRecordsInView] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageFirst, setPageFirst] = useState(0);
  const [isFilterChange, setIsFilterChange] = useState([]);
  const [commentActivityHistory, setCommentActivityHistory] = React.useState([]);
  const [sortingData, setSortingData] = useState({
    sortBy: "",
    sortOrder: "",
  });
  const [mobileToolboxOpen, setMobileToolboxOpen] = useState(false);
  const dt = useRef(null);
  const overlayRefs = useRef({});
  const lazyLoadInFlightRef = useRef(false);
  const clientsRef = useRef([]);
  const recordsInViewRef = useRef(0);
  const pageSize = 100;

  const setRecordsInViewSafe = (nextValue) => {
    setRecordsInView((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      recordsInViewRef.current = next;
      return next;
    });
  };

  const setClientsSafe = (nextValue) => {
    setClients((old) => {
      const next = typeof nextValue === "function" ? nextValue(old) : nextValue;
      clientsRef.current = next;
      return next;
    });
  };

  const [data, setData] = useState([]);
  const [jurisdiction, setJurisdiction] = useState([]);
  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    customerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    juristiction: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    categories: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    programLists: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    address: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    taxNumber: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    phone: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    parentCustomerName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
    },
    // 'country.name': { value: null, matchMode: FilterMatchMode.CONTAINS },
    // representative: { value: null, matchMode: FilterMatchMode.IN },
    // status: { value: null, matchMode: FilterMatchMode.EQUALS },
    // verified: { value: null, matchMode: FilterMatchMode.EQUALS }
    trackNowLicenseName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    postAwardLicenseName: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
    stateList: {
      operator: FilterOperator.AND,
      constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
    },
  });
  const tracknowlicenseTypes = ["Essential", "Plus", "Premium"];
  const postawardlicenseTypes = ["Essential", "Premium", "Platinum"];
  const [globalFilterValue, setGlobalFilterValue] = useState("");

  const [showHistory, setShowHistory] = useState(false);
  const [activityHistory, setActivityHistory] = React.useState([]);

  const displayFilter = () => {
    console.log("Toggling Show Filter", showFilter);
    setShowFilter(() => true);
  };

  const displayComments = (rowData) => {
    console.log("Display Comments", selectedClients);
    console.log("rowData", rowData);

    // setShowComments(() => false);
    if (rowData && rowData.customerId) {
      console.log(`Fetching Commnet for :${rowData.customerId}`);
      fetchCustomerComments(rowData.customerId);
      setShowComments(() => true);
      setSelectedClients(rowData);
    } else if (selectedClients && selectedClients.customerId) {
      console.log(`Fetching Commnet for :${selectedClients.customerId}`);
      fetchCustomerComments(selectedClients.customerId);
      setShowComments(() => true);
    } else {
      showSelectionRequiredPopup();
    }
  };
  const closeComments = () => {
    setShowComments(() => false);
  };
  const handleViewAllClick = () => {
    setViewAll(true);
  };

  const handlePaginationClick = () => {
    setViewAll(false);
  };

  const displayCategories = () => {
    console.log("Display Categories", selectedClients);
    // setShowComments(() => false);
    if (selectedClients && selectedClients.customerId) {
      console.log(`Fetching Categories for :${selectedClients.customerId}`);
      fetchCustomerCategories(selectedClients.customerId);
      fetchBusinessCategories();
      console.log(`Display Categories for :${selectedClients.customerId}`);
      setShowCategories(() => true);
    } else {
      showSelectionRequiredPopup();
    }
  };

  const closeCategories = () => {
    setShowCategories(() => false);
  };

  const closeFilter = () => {
    console.log("Toggling Show Filter", showFilter);
    setShowFilter(() => false);
  };

  const closeHistory = () => {
    console.log("Toggling Show Filter", showHistory);
    setShowHistory(() => false);
  };

  const showSelectionRequiredPopup = (message = "Please Select a Client Record") => {
    setAlertConfig({
      header: "Selection Required",
      icon: "\u26A0\uFE0F",
    });
    setAlertMessage(message);
    setShowAlert(true);
  };

  const showActionRequiredPopup = (message) => {
    setAlertConfig({
      header: "Action Required",
      icon: "\u26A0\uFE0F",
    });
    setAlertMessage(message);
    setShowAlert(true);
  };

  const showSuccessPopup = (message) => {
    setAlertConfig({
      header: "Success",
    });
    setAlertMessage(message);
    setShowAlert(true);
  };

  const showErrorPopup = (message) => {
    setAlertConfig({
      header: "Error",
      icon: "\u274C",
    });
    setAlertMessage(message);
    setShowAlert(true);
  };

  const editCustomer = () => {
    console.log("Editing Customer", selectedClients);
    if (selectedClients) {
      setCurrentCustomer(selectedClients);
      navigate("/customer");
    } else {
      showSelectionRequiredPopup();
    }
  };

  const displayHistory = async () => {
    console.log("displayHistory", selectedClients);
    if (selectedClients) {
      console.log(`displayHistory for : ${selectedClients.customerId}`);
      fetchClientTrackingHistory(selectedClients.customerId);
      setShowHistory(() => true);
    } else {
      showSelectionRequiredPopup();
    }
  };

  const fetchClientTrackingHistory = async (customerId) => {
    console.log("fetchClientTrackingHistory props", customerId);
    try {
      const history = await axios.get(
        `${API_BASE_URL}/Customer/Customeraudit?CustomerId=${customerId}`
      );
      console.log("fetchClientTrackingHistory res", history);
      setActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
    try {
      const history = await axios.get(
        `${API_BASE_URL}/Customer/CustomerCommentsAudit?CustomerId=${customerId}`
      );
      setCommentActivityHistory(() => history.data.data);
    } catch (error) {
      console.log("@@Error:", error);
    }
  };

  const displayClientFiling = (rowData) => {
    console.log("Filing for Customer", selectedClients, rowData);
    if (rowData) {
      setCurrentCustomer(rowData);
      navigate(`client-filing-tracker-list/${rowData.customerId}`, { state: { clientName: rowData.customerName } });
    } else if (selectedClients) {
      setCurrentCustomer(selectedClients);
      navigate(`client-filing-tracker-list/${selectedClients.customerId}`, { state: { clientName: selectedClients.customerName } });
    } else {
      showSelectionRequiredPopup();
    }
  };




  const displayAddClientFiling = () => {
    console.log("Add Filing for Customer", selectedClients);
    if (selectedClients) {

      if ((selectedClients?.postAwardLicenseId === null || selectedClients?.postAwardLicenseId === "" || Number(selectedClients?.postAwardLicenseId) === 0) && (selectedClients?.trackNowLicenseId && Number(selectedClients?.trackNowLicenseId) > 0)) {
        //If client has only Tracknow subscription
        navigate(`/add-filings/${selectedClients.customerId}`, { state: { clientName: selectedClients.customerName } });

      } else if ((selectedClients?.trackNowLicenseId === null || selectedClients?.trackNowLicenseId === "" || Number(selectedClients?.trackNowLicenseId) === 0) && (selectedClients?.postAwardLicenseId && Number(selectedClients?.postAwardLicenseId) > 0)) {
        //If client has only Postaward subscription
        navigate(`/add-filing-postaward/${selectedClients.customerId}`, { state: { clientName: selectedClients.customerName } });
      } else if ((selectedClients?.trackNowLicenseId && Number(selectedClients?.trackNowLicenseId) > 0) && (selectedClients?.postAwardLicenseId && Number(selectedClients?.postAwardLicenseId) > 0)) {
        //If client has both Tracknow and  Postaward subscription
        setShowRadio(true);
      } else {
        showActionRequiredPopup("Client doesn't have either tracknow or postaward subscriptions.");
      }

      setCurrentCustomer(selectedClients);
      // navigate(`/add-filings/${selectedClients.customerId}`);
    } else {
      showSelectionRequiredPopup();
    }
  };

  // const onGlobalFilterChange = (e) => {
  //   const value = e.target.value;
  //   let _filters = { ...filters };

  //   _filters["global"].value = value;
  //   console.log("_filters", _filters);
  //   setFilters(_filters);
  //   setGlobalFilterValue(value);
  // };

  const search = useRef(null);

  const applyGlobalFilter = () => {
    console.log("applyGlobalFilter", search.current.value, isClearIcon)
    let _filters = { ...filters };
    if (isClearIcon) {
      search.current.value = "";
      _filters["global"].value = null;
      setIsClearIcon(false);
      onFilterChange({ filters: _filters });
    } else {
      _filters["global"].value = search.current.value;
      setIsClearIcon(Boolean(search.current.value));
      onFilterChange({ filters: _filters });
    }
    setFilters(_filters);
  };

  const jusrisdictionItemTemplate = (option) => {
    return (
      <div className='flex align-items-center'>
        <span>{option}</span>
      </div>
    );
    //   return (
    //     <div className="flex align-items-center gap-2">
    //         <img alt={option.name} src={`https://primefaces.org/cdn/primereact/images/avatar/${option.image}`} width="32" />
    //         <span>{option.name}</span>
    //     </div>
    // );
  };

  // const jurisdictionRowFilterTemplate = (options) => {
  //   console.log("##Options:", options);
  //   return (
  //     <MultiSelect
  //       value={options.value}
  //       options={jurisdiction}
  //       itemTemplate={jusrisdictionItemTemplate}
  //       onChange={(e) => {
  //         console.log("##EOptions:", e);
  //         options.filterApplyCallback(e.value);
  //       }}
  //       placeholder="Any"
  //       maxSelectedLabels={1}
  //       className="p-column-filter"
  //       style={{ minWidth: "10rem", maxWidth: "14rem" }}
  //     />
  //   );
  // };

  const getStateName = (stateCode) => {
    const state = states.find((s) => s.code === stateCode);
    return state ? state.state : stateCode;
  };

  const deleteCustomerRecord = async () => {
    setIsLoading(true);
    try {
      if (deleteCustomer) {
        try {

          // const isParentOfAnotherClient = clients.some(
          //   (client) =>
          //     client.parentCustomerName === selectedClients.customerName
          // );
          // const isChildofAnotherSubChild = selectedClients.bothChildAndSubChild

          if (selectedClients.bothParentAndChild) {
            showActionRequiredPopup(
              "This client is a parent of another client and cannot be deleted."
            );

          }
          else if (selectedClients.bothChildAndSubChild) {
            showActionRequiredPopup(
              "This client is a child of another sub child client and cannot be deleted."
            );
          }
          else {
            const res = await deleteCustomer(selectedClients);
            if (res) {
              setSelectedClients(null);
              setClientsSafe([]);
              setData([]);
              setIsLoading(true);
              setRecordsInViewSafe(0);
              await loadRecordsList(0, pageSize, "down");
              setRecordsInViewSafe(1);
              showSuccessPopup(
                `Successfully deleted Client: ${selectedClients.customerName}`
              );
            } else {
              showErrorPopup("Unexpected error occurred while deleting customer.");
            }
          }
        } catch (error) {
          console.log("@@Error:", error);
        }
      } else {
        showSelectionRequiredPopup();
      }
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCustomers = async (changeBC) => {
    console.log("@@Fetch Customers1:", getCustomers);
    if (getCustomers) {
      console.log("@@Fetch Customers2:");
      try {
        const custList = await getCustomers();
        console.log("@@Customers:", custList);
        if (changeBC) {
          let changeClient = custList.filter(
            (ele) => ele.customerId === selectedClients.customerId
          );
          setSelectedClients(changeClient[0]);
        }
        // console.log("@@Unique Jurisdiction:", _.map(custList, "jurisdiction"));
        // console.log(
        //   "@@Unique Jurisdiction:",
        //   _.unique(_.map(custList, "jurisdiction"))
        // );
        // const _jusrisdictions = custList.map((item) =>
        //   item.juristiction ? item.juristiction : ""
        // );
        // const _uniqJurisdictions = Array.from(new Set(_jusrisdictions));
        // console.log("@@Unique Jurisdiction:", _uniqJurisdictions);
        // setJurisdiction(_uniqJurisdictions);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const fetchCustomerComments = async (customerId) => {
    console.log("@@Fetch Customer comments:", getCustomerComments);
    if (getCustomerComments) {
      console.log("@@Fetch Customer comments2:");
      try {
        const commentList = await getCustomerComments(customerId);
        setComments(() => commentList);
        console.log("@@Fetch Customer2 comments:", commentList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const fetchCustomerCategories = async (customerId) => {
    console.log("@@Fetch Customer categories:", getCustomerBusinessCategories);
    if (getCustomerBusinessCategories) {
      console.log("@@Fetch Customer categories2:");
      try {
        const catList = await getCustomerBusinessCategories(customerId);
        setCategories(() => catList);
        console.log("@@Fetch Customer2 categories:", catList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };

  const fetchBusinessCategories = async () => {
    console.log("@@Fetch BusinessCategories:", getBusinessCategories);
    if (getBusinessCategories) {
      console.log("@@Fetch BusinessCategories:");
      try {
        let resList = await getBusinessCategories();
        console.log("@@BusinessCategories: resList", resList);

        const catList = resList.sort((a, b) => (a.businessCategoryName ?? '').localeCompare(b.businessCategoryName ?? ''));

        console.log("@@BusinessCategories: catList", catList);
        setCategoriesLookup(() => catList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  const fetchProgramName = async () => {
    console.log("@@Fetch fetchProgramName:", fetchProgramName);
    if (fetchProgramName) {
      console.log("@@Fetch fetchProgramName:");
      try {
        let resList = await getProgramName();
        console.log("@@fetchProgramName: resList", resList);

        const programList = resList.sort((a, b) => (a.programName ?? '').localeCompare(b.programName ?? ''));

        console.log("@@fetchProgramName: programList", programList);
        setProgramList(() => programList);
      } catch (error) {
        console.log("@@Error:", error);
      }
    }
  };
  // const onRowSelect = (e) => {
  //   console.log("@@RowSelect:", e);
  // };

  // useEffect(() => {
  //   if (customerLoaded) console.log("Show Table Data", customers);

  //   //eslint-disable-next-line
  // }, [customerLoaded]);

  useEffect(() => {
    console.log("@@DATA REFRESHH");
    fetchBusinessCategories();
    fetchProgramName();
    let list = states.map((ele) => ele.state);
    setStateList(list);

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    console.log("selectedClients data", selectedClients);
    if (!selectedClients) {
      sessionStorage.removeItem("userIdForComments");
      sessionStorage.removeItem("usernameForComments");
    }
  }, [selectedClients]);

  const parseCellList = (value) => splitCommaSeparatedValues(value);

  const hideOtherCellOverlays = (currentKey) => {
    Object.entries(overlayRefs.current).forEach(([key, overlay]) => {
      if (key !== currentKey && overlay?.hide) {
        overlay.hide();
      }
    });
  };

  const getPreferredOverlayDirection = (cellElement) => {
    const row = cellElement?.closest("tr");
    const body = row?.parentElement;

    if (row && body) {
      const rows = Array.from(body.children).filter(
        (node) => node.tagName === "TR"
      );
      const rowIndex = rows.indexOf(row);

      if (rowIndex >= rows.length - 3) {
        return "up";
      }
      if (rowIndex <= 2) {
        return "down";
      }
    }

    const cellRect = cellElement?.getBoundingClientRect();
    if (!cellRect) {
      return "down";
    }
    return cellRect.bottom > window.innerHeight * 0.7 ? "up" : "down";
  };

  const positionOverlayNearCell = (overlayKey, cellElement, preferredDirection) => {
    const overlayPanel = overlayRefs.current[overlayKey];
    const overlayElement = overlayPanel?.container;
    if (!overlayElement || !cellElement || overlayElement.style.display === "none") {
      return;
    }

    const cellRect = cellElement.getBoundingClientRect();
    const overlayRect = overlayElement.getBoundingClientRect();
    const gap = 8;
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;
    const canOpenDown = cellRect.bottom + overlayRect.height + gap <= viewportHeight;
    const canOpenUp = cellRect.top - overlayRect.height - gap >= gap;

    let openUp = false;
    if (preferredDirection === "up" && canOpenUp) {
      openUp = true;
    } else if (preferredDirection === "down" && !canOpenDown && canOpenUp) {
      openUp = true;
    } else if (!canOpenDown && canOpenUp) {
      openUp = true;
    }

    let top = openUp
      ? cellRect.top - overlayRect.height - gap
      : cellRect.bottom + gap;
    let left = cellRect.left + cellRect.width / 2 - overlayRect.width / 2;

    left = Math.min(Math.max(left, gap), viewportWidth - overlayRect.width - gap);
    top = Math.min(Math.max(top, gap), viewportHeight - overlayRect.height - gap);

    overlayElement.style.position = "fixed";
    overlayElement.style.left = `${Math.round(left)}px`;
    overlayElement.style.top = `${Math.round(top)}px`;
    overlayElement.style.transform = "none";
  };

  const toggleCellOverlay = (event, overlayKey) => {
    event.stopPropagation();
    event.preventDefault();
    const targetElement = event.currentTarget;

    const overlayPanel = overlayRefs.current[overlayKey];
    if (!overlayPanel?.toggle) return;

    const overlayElement = overlayPanel.container;
    const isVisible = Boolean(
      overlayElement && overlayElement.style.display !== "none"
    );

    if (!isVisible) {
      hideOtherCellOverlays(overlayKey);
    }

    overlayPanel.toggle(event);

    requestAnimationFrame(() => {
      const preferredDirection = getPreferredOverlayDirection(targetElement);
      positionOverlayNearCell(overlayKey, targetElement, preferredDirection);
    });
  };

  const renderExpandableCell = ({ list, overlayKey, title }) => {
    if (list.length === 0) return "";

    const hasValue = list.length > 0;
    const hasMore = list.length > 1;
    const firstItem = list[0];
    const remainingCount = Math.max(list.length - 1, 0);

    return (
      <div className='tableBtn' style={{ position: "relative", width: "100%" }}>
        <button
          type='button'
          onClick={(event) => {
            if (!hasValue) return;
            toggleCellOverlay(event, overlayKey);
          }}
          style={{
            background: "transparent",
            border: "none",
            cursor: hasValue ? "pointer" : "default",
            color: primaryColor,
            width: "100%",
            padding: 0,
            textAlign: "left",
            overflow: "hidden",
          }}
        >
          <div className='client-profile-expandable-cell'>
            <span className='client-profile-expandable-primary'>
              {firstItem}
            </span>
            {hasMore && (
              <span
                className='client-profile-more-count'
                style={{ color: primaryColor }}
              >
                {`+${remainingCount} more`}
              </span>
            )}
          </div>
        </button>
        {hasValue && (
          <OverlayPanel
            ref={(el) => {
              if (el) {
                overlayRefs.current[overlayKey] = el;
              }
            }}
            className='client-profile-overlay-panel'
            showCloseIcon
            dismissable
            style={{
              padding: "0.4rem 0.8rem",
              width: "min(22rem, calc(100vw - 1rem))",
              maxWidth: "min(22rem, calc(100vw - 1rem))",
              maxHeight: "min(18rem, calc(100vh - 1rem))",
            }}
          >
            <Typography variant='subtitle2' sx={{ mb: 1, fontWeight: 600 }}>
              {title}
            </Typography>
            <div className='client-profile-overlay-scroll overlay-scroll-consistent'>
              <ul style={{ paddingLeft: "20px", margin: 0 }}>
                {list.map((item, idx) => (
                  <li key={`${item}-${idx}`} style={{ marginBottom: "4px" }}>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </OverlayPanel>
        )}
      </div>
    );
  };

  const CellListDisplayFederal = (rowData) => {
    const categories = parseCellList(rowData.categories);
    return renderExpandableCell({
      list: categories,
      overlayKey: `federal-${rowData.customerId}`,
      title: "Federal Business Category",
    });
  };

  const CellListDisplayProgram = (rowData) => {
    const programLists = parseCellList(rowData.programLists);
    return renderExpandableCell({
      list: programLists,
      overlayKey: `program-${rowData.customerId}`,
      title: "Program Names",
    });
  };

  const CellListDisplayState = (rowData) => {
    const stateList = parseCellList(rowData.stateList);
    return renderExpandableCell({
      list: stateList,
      overlayKey: `state-${rowData.customerId}`,
      title: "States",
    });
  };

  const cellListDisplayNotes = (rowData) => {
    const notesUrl = rowData.notes;
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    if (!notesUrl) return null;

    const formattedText = notesUrl.replace(
      urlRegex,
      '<a style="color:#0000FF;" href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
    );

    return (
      <LightTooltip
        arrow
        title={
          <div
            style={{
              maxWidth: "350px",
              maxHeight: "250px",
              overflowY: "auto",
              overflowX: "hidden",
              whiteSpace: "pre-wrap",
              wordBreak: "break-word",
              overflowWrap: "anywhere",
              padding: "4px",// Added top/bottom & left/right padding
              fontWeight: "normal",   // Remove bold
              lineHeight: "1.5",      // Better readability
              fontSize: "14px",
            }}
            dangerouslySetInnerHTML={{ __html: formattedText }}
          />
        }
      >
        <div
          style={{
            width: "100%",
            maxWidth: "320px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            cursor: "pointer",
          }}
          dangerouslySetInnerHTML={{ __html: formattedText }}
        />
      </LightTooltip>
    );
  };

  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#F1F2F6",
      color: "black",
      boxShadow: theme.shadows[1],
      fontSize: 12,
    },
  }));

  const clearSelectedClient = () => {
    sessionStorage.removeItem("userIdForComments");
    sessionStorage.removeItem("usernameForComments");
    setSelectedClients(null);
  };

  const selectRow = (data) => {
    console.log("row data", data);
    if (!data) {
      clearSelectedClient();
      return;
    }

    if (selectedClients?.customerId === data.customerId) {
      clearSelectedClient();
      return;
    }

    sessionStorage.setItem("userIdForComments", data.customerId);
    sessionStorage.setItem("usernameForComments", data.customerName);
    setSelectedClients(data);
  };

  const IsDisabled = (page, action) => {
    return !usePermission(page, action);
  };

  const loadDataLazy = async (event) => {
    if (lazyLoadInFlightRef.current || lazyLoading) {
      return;
    }

    const vScroll = dt.current?.getVirtualScroller?.();
    if (!vScroll?.getRenderedRange) {
      return;
    }

    let range = vScroll.getRenderedRange();
    if (!range?.viewport) {
      return;
    }
    let { first, last } = range.viewport;
    let firstVal = recordsInViewRef.current * pageSize;
    const currentClientsLength = clientsRef.current.length;

    if (
      firstVal < totalRecords &&
      first > currentClientsLength - pageSize / 5 &&
      !lazyLoading
    ) {
      lazyLoadInFlightRef.current = true;
      setLazyLoading(true);
      let lastVal = Math.min(firstVal + pageSize, totalRecords);
      try {
        let records = await loadRecordsList(firstVal, lastVal, "down");
        if (Array.isArray(records) && records.length > 0) {
          if (typeof vScroll.scrollInView === "function") {
            vScroll.scrollInView(recordsInViewRef.current * 100);
          } else if (typeof vScroll.scrollToIndex === "function") {
            vScroll.scrollToIndex(recordsInViewRef.current * 100);
          }
          setRecordsInViewSafe((old) => old + 1);
        }
      } finally {
        setLazyLoading(false);
        setIsLoading(false);
        lazyLoadInFlightRef.current = false;
      }
    } else if (last < pageSize / 5 && recordsInViewRef.current > 1 && !lazyLoading) {
      let firstVal = (recordsInViewRef.current - 3) * pageSize;
      let lastVal = Math.min(firstVal + pageSize, totalRecords);
      if (firstVal >= 0) {
        lazyLoadInFlightRef.current = true;
        setLazyLoading(true);
        try {
          let records = await loadRecordsList(firstVal, lastVal, "up");
          if (Array.isArray(records) && records.length > 0) {
            if (typeof vScroll.scrollToIndex === "function") {
              vScroll.scrollToIndex(pageSize * 1.5);
            } else if (typeof vScroll.scrollInView === "function") {
              vScroll.scrollInView(pageSize * 1.5);
            }
            setRecordsInViewSafe((old) => old - 1);
          }
        } finally {
          setLazyLoading(false);
          setIsLoading(false);
          lazyLoadInFlightRef.current = false;
        }
      }
    }
  };
  const tracknowcellStatusEditorBody = (rowData) => {
    return rowData["trackNowLicenseName"];
  };
  const postawardcellStatusEditorBody = (rowData) => {
    return rowData["postAwardLicenseName"];
  };
  const tracknowlicenseTypeFilter = (options) => {
    console.log("##Options:", options);
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={options.value}
        options={tracknowlicenseTypes}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##EOptions:", e);
          options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={options.value[0]}
        options={tracknowlicenseTypes}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };
  const postawardlicenseTypeFilter = (options) => {
    console.log("##Options:", options);
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={options.value}
        options={postawardlicenseTypes}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("##EOptions:", e);
          options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={options.value[0]}
        options={postawardlicenseTypes}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };
  const renderHeader = () => {
    return (
      <Grid container sx={{ my: 1, flexDirection: "column" }}>

        {/* ROW 1 — TITLE */}
        <Grid item sx={{ margin: 1 }}>
          <Typography
            variant="h6"
            sx={{
              fontWeight: 400,
              display: "flex",
              alignItems: "center",
            }}
          >
            CLIENT PROFILE LIST ({totalRecords})
          </Typography>
        </Grid>


        {/* ROW 2 — CONTROLS */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          sx={{ px: 1 }}
        >

          {/* LEFT SIDE (FILTER) */}
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2
            }}
          >
            <TrackNowButton
              variant="secondary"
              size="small"
              onClick={(e) => setFilterAnchorEl(e.currentTarget)}
              sx={{
                fontSize: "12px",
                padding: "4px 12px",
                minHeight: "28px"
              }}
            >
              + Filter
            </TrackNowButton>
          </Grid>


          {/* RIGHT SIDE */}
          <Grid
            item
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 2,
              flexWrap: "wrap"
            }}
          >



            <TrackNowButton
              variant="primary"
              onClick={() => navigate("/filing-master-list")}
              disabled={IsDisabled("MasterFilingList", "viewPage")}
              size="small"
            >
              Master Filing List
            </TrackNowButton>

            <TrackNowButton
              variant="primary"
              onClick={() => navigate("/postaward-filing-master-list")}
              disabled={IsDisabled("PostAwardMasterList", "viewPage")}
              size="small"
            >
              Post Award Master
            </TrackNowButton>

            {/* SEARCH */}
            <TextField
              inputRef={search}
              placeholder="Search by Client Name..."
              size="small"
              sx={{
                width: 280,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "20px",
                  backgroundColor: "#f3f4f6"
                }
              }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={applyGlobalFilter} size="small">
                      {isClearIcon ? (
                        <GoogleMaterialIcon name="clear" size={20} />
                      ) : (
                        <GoogleMaterialIcon name="search" size={20} />
                      )}
                    </IconButton>
                  </InputAdornment>
                )
              }}
            />

          </Grid>
        </Grid>


        {/* ACTIVE FILTERS */}
        <Grid container sx={{ mt: 1, px: 1, flexWrap: "wrap" }}>
          {activeFilters.map((filter, index) => (
            <Grid key={index} sx={{ margin: 0.5 }}>
              <div
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  backgroundColor: tokens.colors.offWhite,
                  border: "1px solid #ccc",
                  borderRadius: "20px",
                  padding: "6px 12px",
                  fontSize: "13px",
                  color: "#333"
                }}
              >
                <span>
                  {filter.label}:{" "}
                  {Array.isArray(filter.displayValue)
                    ? filter.displayValue.join(", ")
                    : filter.displayValue}
                </span>

                <button
                  onClick={() => removeFilter(index)}
                  style={{
                    marginLeft: "6px",
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    fontSize: "16px"
                  }}
                >
                  ×
                </button>
              </div>
            </Grid>
          ))}
        </Grid>

      </Grid>
    );
  };
  const federelBusinessFilterElement = (options) => {
    console.log("options99", options);
    console.log("##Options1234:", JSON.parse(JSON.stringify(clients)));

    console.log("CategoryLocup", categoriesLookup);
    let optionCatList = categoriesLookup.map((item) => item.businessCategoryName)

    console.log("optionCatList", optionCatList);

    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (

      <MultiSelect
        value={options.value ? federalFilterSelectedValues : []}
        options={optionCatList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFederalFilterSelectedValues(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={options.value ? federalFilterSelectedValues : []}

        options={optionCatList}

        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, data);
          setFederalFilterSelectedValues(e.value);
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };
  const programNameFilterElement = (options) => {
    console.log("options99", options);
    console.log("##Options1234:", JSON.parse(JSON.stringify(clients)));

    // let namesList = [];
    // clients
    //   .map((item) => item.programLists)
    //   .filter(Boolean)
    //   .map((item) => {
    //     if (item.includes(",")) {
    //       console.log("spliited_item", item);
    //       item.split(",").map((subItem) => {
    //         namesList.push(subItem);
    //       });
    //     } else {
    //       namesList.push(item);
    //     }
    //   });
    // namesList = namesList
    //   .filter((item, i) => {
    //     return i === namesList.lastIndexOf(item);
    //   })
    //   .sort();
    const optionList = programList.map((item) => item.programName)
    console.log("optionList", optionList);

    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (

      <MultiSelect
        value={options.value ? programNamesSelectedValues : []}
        options={optionList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          console.log("programNameFilterElement e", e);
          setProgramNamesSelectedValues(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "12rem", maxWidth: "12em" }}
      />
    ) : (
      <Dropdown
        value={options.value ? programNamesSelectedValues : []}
        options={optionList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, data);
          setProgramNamesSelectedValues(e.value);
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const filterCustomerState = (options, field) => {
    console.log("##Options1234:", JSON.parse(JSON.stringify(clients)));
    console.log("option-Check", options);
    console.log("Client-Check", clients);

    console.log("STATE#-OPTION", options);
    console.log("STATE#-FILTERSTATE", filterState);
    return options.filterModel?.matchMode &&
      options.filterModel.matchMode === "in" ? (
      <MultiSelect
        value={options.value ? filterState : []}
        options={stateList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          setFilterState(e.value);
          options.filterCallback(e.value, options.index);
        }}
        placeholder='Any'
        maxSelectedLabels={1}
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    ) : (
      <Dropdown
        value={options.value ? filterState : []}
        options={stateList}
        itemTemplate={jusrisdictionItemTemplate}
        onChange={(e) => {
          // console.log("##federalFilterElement#:", options, e, data);
          setFilterState(e.value);
          let values = [];

          if (options.filterModel.matchMode === "equals") {
            values.push(e.value);
          } else if (options.filterModel.matchMode === "notContains") {
            values.push(e.value);
          }
          options.filterCallback(values, options.index);
        }}
        placeholder='Any'
        className='p-column-filter'
        style={{ minWidth: "14rem", maxWidth: "14rem" }}
      />
    );
  };

  const CustomCommentButton = ({ rowData }) => {
    const isPermissionEnabled = usePermission("ClientProfile", "comments", rowData.customerId);
    const hasComments = rowData.hasComments === true || rowData.hasComments === 1;
    const isActive = hasComments && isPermissionEnabled;
    const isDisabled = !isActive;

    return (
      <IconButton
        disabled={!isActive}
        onClick={() => displayComments(rowData)}
        sx={{
          p: "4px",
          width: 28,
          height: 28,
          minWidth: 28,
          minHeight: 28,
          pointerEvents: isDisabled ? 'none' : 'auto',
          cursor: isDisabled ? 'default' : 'pointer',
          backgroundColor: isActive ? `color-mix(in srgb, ${primaryColor} 12%, white)` : 'transparent',
          '&:hover': {
            backgroundColor: isActive ? alpha(primaryColor, 0.2) : 'transparent'
          },
          '&.Mui-disabled': {
            backgroundColor: 'transparent',
          }
        }}
      >
        <GoogleMaterialIcon
          name="comment"
          size={20}
          color={isActive ? primaryColor : tokens.colors.grey}
        />
      </IconButton>
    );
  };
  const handleRadioChange = (event) => {
    setRadioVal((event.target).value);
  };
  const header = renderHeader();
  const renderSortIcon = (options) => {
    if (options.sorted) {
      return options.sortOrder === 1 ? (
        <GoogleMaterialIcon name="arrow_upward" size={16} color="#ffffff" />
      ) : (
        <GoogleMaterialIcon name="arrow_downward" size={16} color="#ffffff" />
      );
    }
    return <GoogleMaterialIcon name="unfold_more" size={16} color="#ffffff" />;
  };
  const radioFooterContent = (
    <div>
      <TrackNowButton variant="primary" onClick={() => radioOkButton()}>
        Submit
      </TrackNowButton>
    </div>
  );


  const closeAlert = () => {
    setShowAlert(false);
  };

  const applyNewFilter = (filterConfig) => {
    console.log("applyNewFilter", filterConfig);
    // Create filters structure matching old PrimeReact format
    let _filters = { ...filters };
    const tableMatchMode = getClientProfileTableMatchMode(
      filterConfig.field,
      filterConfig.matchMode
    );

    // Reset the specific field filter
    _filters[filterConfig.field] = {
      operator: "AND",
      constraints: [{
        value: filterConfig.value,
        matchMode: tableMatchMode
      }]
    };

    setFilters(_filters);

    // Add to active filters for display
    const columnLabels = {
      customerName: "Client Name",
      parentCustomerName: "Parent Client Name",
      childCustomerName: "Child Client Name",
      categories: "Federal Business Category",
      programLists: "Program Names",
      address: "Address",
      stateList: "States",
      taxNumber: "Tax Number",
      phone: "Phone",
      trackNowLicenseName: "TrackNow Subscription",
      postAwardLicenseName: "PostAward Subscription"
    };

    const newFilter = {
      field: filterConfig.field,
      label: columnLabels[filterConfig.field],
      displayValue: Array.isArray(filterConfig.value) ? filterConfig.value : [filterConfig.value],
      matchMode: filterConfig.matchMode,
      value: filterConfig.value
    };

    // Remove existing filter for same field and add new one
    const updatedFilters = activeFilters.filter(f => f.field !== filterConfig.field);
    setActiveFilters([...updatedFilters, newFilter]);

    // Reset table state before applying filter
    setSelectedClients(null);
    setRecordsInViewSafe(0);
    setData([]);
    setClientsSafe([]);

    // Trigger the existing onFilterChange logic
    onFilterChange({ filters: _filters });
  };

  const removeFilter = (index) => {
    const filterToRemove = activeFilters[index];

    // Remove from active filters
    const updatedFilters = activeFilters.filter((_, i) => i !== index);
    setActiveFilters(updatedFilters);

    // Reset the filter in the filters state
    let _filters = { ...filters };
    const inMatchModeFields = ["categories", "programLists", "trackNowLicenseName", "postAwardLicenseName", "stateList"];
    _filters[filterToRemove.field] = {
      operator: "AND",
      constraints: [{
        value: null,
        matchMode: inMatchModeFields.includes(filterToRemove.field)
          ? FilterMatchMode.IN
          : FilterMatchMode.CONTAINS
      }]
    };

    setFilters(_filters);

    // Trigger filter change
    onFilterChange({ filters: _filters });
  };

  const clearAllFilters = () => {
    console.log("clearAllFilters");

    // Clear active filters display
    setActiveFilters([]);
    // Reset all filters to initial state
    const resetFilters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      customerName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      juristiction: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
      },
      categories: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
      },
      programLists: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
      },
      address: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      taxNumber: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      phone: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      parentCustomerName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.CONTAINS }],
      },
      trackNowLicenseName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
      },
      postAwardLicenseName: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
      },
      stateList: {
        operator: FilterOperator.AND,
        constraints: [{ value: null, matchMode: FilterMatchMode.IN }],
      },
    };

    setFilters(resetFilters);

    // Reset filter state variables
    setFederalFilterSelectedValues([]);
    setProgramNamesSelectedValues([]);
    setFilterState([]);
    setIsClearIcon(false);
    if (search.current) {
      search.current.value = "";
    }

    // Clear the API filter changes
    setIsFilterChange([]);
  };
  const radioCloseAlert = () => {
    setShowRadio(false);
  };
  const radioOkButton = () => {
    if (radioVal === "tracknow") {
      navigate(`/add-filings/${selectedClients.customerId}`, { state: { clientName: selectedClients.customerName } });
    }
    else {
      navigate(`/add-filing-postaward/${selectedClients.customerId}`, { state: { clientName: selectedClients.customerName } });
    }
  }

  const loadRecordsList = async (first, last, direction = "down") => {
    console.log("loadRecordsList props", first, last, direction);
    setIsLoading(true);

    const isAdminIncludes = Boolean(roleType?.includes("Admin") || roleType?.includes("Admin-PostAward"));
    let url = `${API_BASE_URL}/Customer/CustomerListByPagination?StartRow=${first + 1}&EndRow=${last}`;
    if (!isAdminIncludes) {
      url += `&UserID=${authId}`;
    }

    if (isFilterChange !== undefined && isFilterChange.length > 0) {
      isFilterChange.forEach((ele) => {
        url = `${url}&${ele.name}=${ele.val}${ele.searchType ? `&${ele.searchType}=${ele.searchTypeVal}` : ``}`;
      });
    }

    if (
      sortingData &&
      typeof sortingData === "object" &&
      sortingData.sortBy !== "" &&
      sortingData.sortOrder !== ""
    ) {
      const sortParameter = getSortData(sortingData.sortBy);
      const order = sortingData.sortOrder === 1 ? "Ascending" : "Descending";
      url = `${url}&${sortParameter.SortByParameter}=${sortParameter.SortByVal}&${sortParameter.SortOrderParameter}=${order}`;
    }

    console.log("loadRecordsList url", url);
    try {
      const res = await axios.get(url);
      console.log("loadRecordsList res", res.data);

      if (res.data) {
        setIsLoading(true);
        const ogList = first === 0 ? [] : clientsRef.current.map((ele) => ele);
        setTotalRecords(res.data.totalItems);
        await modifyList(res.data.items || [], direction, ogList);
        return res.data.items;
      }
      return false;
    }
    catch (err) {
      console.log("loadRecordsList err", err);
      setLazyLoading(false);
      setIsLoading(false);
      return false;
    }
  };

  const sortRowsForParentAndStates = (rows, sortBy, sortOrder) => {
    if (!Array.isArray(rows) || rows.length <= 1) return rows;
    if (!(sortBy === "parentCustomerName" || sortBy === "stateList")) return rows;

    const direction = sortOrder === -1 ? -1 : 1;

    return [...rows].sort((a, b) => {
      const aValue = (a?.[sortBy] ?? "").toString().trim();
      const bValue = (b?.[sortBy] ?? "").toString().trim();

      if (aValue === bValue) return 0;

      const aIsEmpty = aValue.length === 0;
      const bIsEmpty = bValue.length === 0;
      if (aIsEmpty || bIsEmpty) {
        if (aIsEmpty && bIsEmpty) return 0;
        return aIsEmpty ? 1 : -1;
      }

      return (
        aValue.localeCompare(bValue, undefined, {
          sensitivity: "base",
        }) * direction
      );
    });
  };

  const modifyList = (list, direction, ogList) => {
    if (list.length === 0) {
      setRefreshRecordList(false);
      setLazyLoading(false);
      setIsLoading(false);
      setData([]);
      setClientsSafe([]);
      return [];
    }

    let updCustomers = list.map((item) => ({
      ...item,
      stateList: item.customerState?.map(s => getStateName(s.state)).join(", ") || "",
      categories: item.businessCategory?.filter(c => !c.state).map(c => c.businessCategoryName).join(", ") || "",
      programLists: item.programinfo?.map(p => p.programName).join(",") || "",
      parentCustomerName: item.parentCustomer?.customerName || "",
    }));
    console.log("roleType", roleType);

    // if (!(roleType.includes("Admin") || roleType.includes("Admin-PostAward") || roleType.includes("HierarchyAdmin-PostAward") || roleType.includes("HierarchyAdmin"))) {
    //   console.log("updCustomers 1", updCustomers);
    //   updCustomers = updCustomers.filter(ele => authUser.clients.includes(ele.customerId));
    //   console.log("updCustomers 2", updCustomers);
    //   setTotalRecords(updCustomers.length);
    // }

    const tableList = clientsRef.current;
    let updFilingMastersList;

    if (direction === "down") {
      updFilingMastersList = tableList.length >= pageSize * 2
        ? [...ogList.slice(pageSize), ...updCustomers]
        : [...ogList, ...updCustomers];
    } else {
      updFilingMastersList = tableList.length >= pageSize * 2
        ? [...updCustomers, ...ogList.slice(0, pageSize)]
        : [...updCustomers, ...ogList.slice(0, pageSize)];
    }

    const sortedRows = sortRowsForParentAndStates(
      updFilingMastersList,
      sortingData.sortBy,
      sortingData.sortOrder
    );

    setData(sortedRows);
    setClientsSafe(sortedRows);
    setRefreshRecordList(false);
    setLazyLoading(false);
    setIsLoading(false);
    return sortedRows;
  };

  const onFilterChange = async (e) => {
    console.log("onFilterChange props", e.filters);
    let filterChange = [];

    if (e.filters.global.value !== "" && e.filters.global.value !== null) {
      //global filter
      filterChange.push({
        name: `SearchByClientName`,
        val: e.filters.global.value,
        searchType: `ClientNameSearchType`,
        searchTypeVal: getSearchType("contains"),
      });
    } else {
      //map filter event
      Object.keys(e.filters).forEach((col) => {
        const constraint = e.filters[col]?.constraints?.[0];

        // console.log("onFilterChange col", col, e.filters[col]);
        if (constraint && constraint.value !== null) {
          const matchMode = normalizeClientProfileMatchMode(
            constraint.matchMode
          );
          const values = Array.isArray(constraint.value)
            ? constraint.value
            : [constraint.value];

          if (col === "stateList") {
            values.forEach((ele, i) => {
              let changeItem = {
                name: `SearchByStates`,
                val: getStateCode(ele),
              };
              if (i + 1 === values.length) {
                changeItem.searchType = `StatesSearchType`;
                changeItem.searchTypeVal = getSearchType(matchMode);
              }
              filterChange.push(changeItem);
            });
          } else if (col === "customerName") {
            filterChange.push({
              name: `SearchByClientName`,
              val: constraint.value,
              searchType: `ClientNameSearchType`,
              searchTypeVal: getSearchType(matchMode),
            });
          } else if (col === "parentCustomerName") {
            filterChange.push({
              name: `SearchByParentClientName`,
              val: constraint.value,
              searchType: `ParentClientNameSearchType`,
              searchTypeVal: getSearchType(matchMode),
            });
          }
          else if (col === "childCustomerName") {
            filterChange.push({
              name: `SearchByChildCustomer`,
              val: constraint.value,
              searchType: `ChildCustomerSearchType`,
              searchTypeVal: getSearchType(matchMode),
            });
          }
          else if (col === "categories") {
            values.forEach((ele, i) => {
              let changeItem = {
                name: `WhoMustFileFederal`,
                val: ele,
              };
              if (i + 1 === values.length) {
                changeItem.searchType = `WhoMustFileFederalSearchType`;
                changeItem.searchTypeVal = getSearchType(matchMode);
              }
              filterChange.push(changeItem);
            });
          } else if (col === "programLists") {
            values.forEach((ele, i) => {
              // console.log(
              //   "onFilterChange i",
              //   i + 1,
              //   values.length
              // );
              let changeItem = {
                name: `SearchByProgramNames`,
                val: ele,
              };
              if (i + 1 === values.length) {
                changeItem.searchType = `ProgramNameSearchType`;
                changeItem.searchTypeVal = getSearchType(matchMode);
              }
              filterChange.push(changeItem);
            });
          } else if (col === "trackNowLicenseName") {
            values.forEach((ele, i) => {
              // console.log(
              //   "onFilterChange i",
              //   i + 1,
              //   values.length
              // );
              let changeItem = {
                name: `SearchByTracknowSubscription`,
                val: ele,
              };
              if (i + 1 === values.length) {
                changeItem.searchType = `TracknowSubscriptionSearchType`;
                changeItem.searchTypeVal = getSearchType(matchMode);
              }
              filterChange.push(changeItem);
            });
          } else if (col === "postAwardLicenseName") {
            values.forEach((ele, i) => {
              // console.log(
              //   "onFilterChange i",
              //   i + 1,
              //   values.length
              // );
              let changeItem = {
                name: `SearchByPostawardSubscription`,
                val: ele,
              };
              if (i + 1 === values.length) {
                changeItem.searchType = `PostawardSubscriptionSearchType`;
                changeItem.searchTypeVal = getSearchType(matchMode);
              }
              filterChange.push(changeItem);
            });
          } else {
            filterChange.push({
              name: `SearchBy${col}`,
              val: constraint.value,
              searchType: `${col}SearchType`,
              searchTypeVal: getSearchType(matchMode),
            });
          }
        }
      });
    }
    console.log("onFilterChange filterChange", filterChange);

    //set filter
    handleSetFilterVariable(filterChange);
  };

  const formatFilterDate = (date) => {
    // console.log("formatFilterDate", date);
    let getDate = new Date(date);
    let formatDate = `${getDate.getFullYear()}-${getDate.getMonth() + 1
      }-${getDate.getDate()}`;
    // console.log("formatFilterDate formatDate", getDate.getFullYear(), formatDate);
    return formatDate;
  };

  const getStateCode = (stateName) => {
    // console.log("getStateCode", stateName, states);
    const state = states.find((s) => s.state === stateName);
    return state ? state.code : stateName;
  };

  const matchModeVal = [
    { name: "contains", val: "Contains" },
    { name: "in", val: "Contains" },
    { name: "notContains", val: "NotContains" },
    { name: "equals", val: "EqualTo" },
    { name: "dateIs", val: "DateIs" },
    { name: "dateIsNot", val: "DateIsNot" },
    { name: "dateBefore", val: "DateIsBefore" },
    { name: "dateAfter", val: "DateIsAfter" },
  ];

  const getSearchType = (matchMode) => {
    // console.log("getSearchType props", matchMode);
    return matchModeVal.find((ele) => ele.name === matchMode).val;
  };

  //set filter
  const handleSetFilterVariable = (filterChange) => {
    console.log("handleSetFilterVariable props", filterChange);
    setIsFilterChange(() => filterChange);
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setData([]);
    setClientsSafe([]);
  };

  //table sort change
  const handleSort = async (e) => {
    console.log("handleSort props", e, e.sortField);
    if (e.sortField !== "") {
      setSortingData(() => ({
        sortBy: e.sortField,
        sortOrder: e.sortOrder,
      }));
      setRecordsInViewSafe(0);
      setIsLoading(true);
      setSelectedClients(null);
      setData([]);
      setClientsSafe([]);
    }
  };

  const getSortData = (val) => {
    console.log("getSortData props", val);
    if (val === "parentCustomerName") {
      return {
        SortByParameter: "SortByParentCustomer",
        SortByVal: "ParentCustome",
        SortOrderParameter: "SortOrderParentCustomer"
      }
    } else if (val === "childCustomerName") {
      return {
        SortByParameter: "SortByChildCustomer",
        SortByVal: "ChildCustomer",
        SortOrderParameter: "SortOrderChildCustomer"
      }
    } else if (val === "programLists") {
      return {
        SortByParameter: "SortByProgramname",
        SortByVal: "Programname",
        SortOrderParameter: "SortOrderProgramname"
      }
    } else if (val === "stateList") {
      return {
        SortByParameter: "SortByStates",
        SortByVal: "States",
        SortOrderParameter: "SortOrderStates"
      }
    } else if (val === "categories") {
      return {
        SortByParameter: "SortBy",
        SortByVal: "WhoMustFileFederal",
        SortOrderParameter: "SortOrder"
      }
    } else {
      return {
        SortByParameter: "SortBy",
        SortByVal: val.charAt(0).toUpperCase() + val.slice(1),
        SortOrderParameter: "SortOrder"
      }
    }
  }

  useEffect(() => {
    console.log("filter/sort change", isFilterChange, sortingData, !lazyLoading, !refreshRecordList);
    if (!lazyLoading && !refreshRecordList) {
      setLazyLoading(true);
      const sortAndFilterApiCall = async () => {
        const records = await loadRecordsList(0, 100, "down");
        setRecordsInViewSafe(1);
        console.log("recordsCheck", records);
        setIsLoading(false);
      };
      sortAndFilterApiCall();
    }
  }, [isFilterChange, sortingData]);


  const tableRefresh = () => {
    setRecordsInViewSafe(0);
    setIsLoading(true);
    setData([]);
    setClientsSafe([]);
    setRefreshRecordList(true);
    setSelectedClientId(selectedClients?.customerId ?? null);
    setSelectedClients(null);
  };

  const refreshRecords = async () => {
    console.log("refreshRecords");
    const vScroll = dt.current.getVirtualScroller();
    const range = vScroll.getRenderedRange();
    console.log("refreshRecords vScroll", vScroll, range);

    const records = await loadRecordsList(0, pageSize, "down");
    if (records) {
      console.log("refreshRecords refreshDetails", refreshDetails);
      if (selectedClientId !== null && selectedClients === null) {
        const selectedId = records.find((ele) => ele.customerId === selectedClientId);
        setSelectedClients(selectedId);
        setSelectedClientId(null);
      }
      if (refreshDetails?.viewport) {
        console.log("refreshRecords scrollInView", refreshDetails.viewport.first);
      }
      setRecordsInViewSafe(1);
    }
  };


  useEffect(() => {
    console.log("refreshRecordList,", refreshRecordList, !lazyLoading);
    if (refreshRecordList && !lazyLoading) {
      setLazyLoading(true);
      refreshRecords();
    }
  }, [refreshRecordList]);

  useEffect(() => {
    console.log("clients,", clients);
    clientsRef.current = clients;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clients, clients.length, JSON.stringify(clients)]);

  useEffect(() => {
    recordsInViewRef.current = recordsInView;
  }, [recordsInView]);

  useEffect(() => { console.log("isLoading", isLoading) }, [isLoading])

  useEffect(() => { console.log("lazyLoading", lazyLoading) }, [lazyLoading])

  return (
    <Box sx={{ display: "flex", justifyContent: "center", width: "100%", px: { xs: 1, sm: 2, md: 3, lg: 4 } }}>
      <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2, width: "100%", maxWidth: "1800px" }}>
        <Box sx={{ flex: 1, minWidth: 0, background: tokens.colors.offWhite, borderRadius: "8px" }}>
          <div
            className='card'
            style={{
              maxWidth: "90vw",
              padding: "1rem",
              //margin: "1rem",
              background: tokens.colors.offWhite,
              borderRadius: "8px",
              position: "relative",
            }}
          >
            <DataTable
              ref={dt}
              className="frozen-client-profile"
              lazy
              scrollable
              value={clients}
              totalRecords={totalRecords}
              emptyMessage='No records found'
              selectionMode='radiobutton'
              selection={selectedClients}
              onSelectionChange={(e) => selectRow(e.value)}
              dataKey='customerId'
              style={{ width: "100%", minWidth: "100%", borderRadius: "8px", overflow: "hidden", border: "none", background: tokens.colors.offWhite }} filters={filters}
              filterMode='multiple'
              globalFilterFields={["customerName", "phone"]}
              header={header}
              loading={isLoading}
              virtualScrollerOptions={{
                onScroll: loadDataLazy,
                itemSize: 45,
                delay: 0,
                scrollHeight: "550px",
                appendOnly: true,
              }}
              scrollHeight='550px'
              onFilter={(e) => onFilterChange(e)}
              sortField={sortingData.sortBy}
              sortOrder={sortingData.sortOrder}
              onSort={(e) => handleSort(e)}
            >
              <Column
                selectionMode='single'
                // frozen={enableForzen}
                headerStyle={{ width: "50px", minWidth: "50px", maxWidth: "50px" }}
                style={{ width: "50px", minWidth: "50px", maxWidth: "50px", textAlign: "center" }}
              />
              <Column
                body={(rowData) => <CustomCommentButton rowData={rowData} />}
                header='Indicator'
                className='indicatorsColumn'
                //  frozen={enableForzen}
                headerStyle={{ width: "80px", minWidth: "80px", maxWidth: "80px" }}
                style={{ width: "80px", minWidth: "80px", maxWidth: "80px", textAlign: "center" }}
              />

              <Column
                field='customerName'
                header='Client Name'
                sortable
                sortIcon={renderSortIcon}
                frozen={enableForzen}
                className='clientNameColumn-cp'
                headerStyle={{ width: "250px", minWidth: "250px", maxWidth: "250px" }}
                style={{ width: "250px", minWidth: "250px", maxWidth: "250px" }}
                body={(rowData) => (
                  <TableCompactButton
                    onClick={() => displayClientFiling(rowData)}
                    style={{ fontSize: "15px", padding: "4px 8px", fontWeight: "normal" }}
                  >
                    {rowData.customerName.length > 35 ? (
                      <Tooltip title={rowData.customerName} arrow>
                        <span>{rowData.customerName.substring(0, 35)}...</span>
                      </Tooltip>
                    ) : (
                      rowData.customerName
                    )}
                  </TableCompactButton>
                )}
              />
              {/* <Column
                field='parentCustomerName'
                header='Parent Client Name'
                sortable
                sortIcon={renderSortIcon}
                frozen={enableForzen}
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
              />
              <Column
                field='childCustomerName'
                header='Child Client Name'
                sortable
                frozen={enableForzen}
                sortIcon={renderSortIcon}
                headerStyle={{ width: "280px", minWidth: "280px", maxWidth: "280px" }}
                style={{ width: "280px", minWidth: "280px", maxWidth: "280px" }}
              /> */}
              <Column
                field='categories'
                header='Federal Business Category'
                className='expandableColumn-cp'
                frozen={enableForzen}
                body={CellListDisplayFederal}
                headerStyle={{ width: "280px", minWidth: "280px", maxWidth: "280px" }}
                style={{ width: "280px", minWidth: "280px", maxWidth: "280px" }}
              />

              <Column
                field='programLists'
                header='Program Names'
                sortable
                sortIcon={renderSortIcon}
                className='expandableColumn-cp'
                frozen={enableForzen}
                body={CellListDisplayProgram}
                headerStyle={{ width: "250px", minWidth: "250px", maxWidth: "250px" }}
                style={{ width: "250px", minWidth: "250px", maxWidth: "250px" }}
              />
              {/* {roleType.includes("JSIPOC") ||
                roleType.includes("Admin") ||
                roleType.includes("JSISME") ? ( */}

              <Column
                field='trackNowLicenseName'
                header='TrackNow Subscription'
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                body={tracknowcellStatusEditorBody}
              />
              {/* ) 
              : null} */}
              {/* {roleType.includes("JSIPOC-PostAward") ||
                roleType.includes("Admin-PostAward") ||
                roleType.includes("JSISME-PostAward") ? ( */}
              <Column
                field='postAwardLicenseName'
                header='PostAward Subscription'
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                body={postawardcellStatusEditorBody}
              />
              {/* ) : null} */}
              <Column
                field='address'
                header='Address'
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
              />
              <Column
                field='stateList'
                header='States'
                sortable
                sortIcon={renderSortIcon}
                className='expandableColumn-cp'
                body={CellListDisplayState}
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
              />
              <Column
                field='taxNumber'
                header='Tax Number'
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
              />
              <Column
                field='phone'
                header='Phone'
                headerStyle={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
                style={{ width: "220px", minWidth: "220px", maxWidth: "220px" }}
              />
              <Column
                field="notes"
                header="Notes"
                headerStyle={{
                  width: "320px",
                  minWidth: "320px",
                  maxWidth: "320px",
                }}
                style={{
                  width: "320px",
                  minWidth: "320px",
                  maxWidth: "320px",
                  overflow: "hidden",
                }}
                body={cellListDisplayNotes}
              />
            </DataTable>
          </div>
        </Box>

        <Paper
          elevation={3}
          sx={{
            width: "48px",
            flexShrink: 0,   // prevents shrinking
            borderRadius: "50px",
            py: 2,
            px: 0.5,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 1.5,
            position: "sticky",
            top: 100,
            backgroundColor: "#ffffff",
          }}
        >
          <Toolbox
            isLoading={isLoading}
            displayFilter={displayFilter}
            editClient={editCustomer}
            deleteClient={deleteCustomerRecord}
            displayComments={displayComments}

            displayClientFiling={displayClientFiling}
            displayAddClientFiling={displayAddClientFiling}
            displayClientCategories={displayCategories}
            displayHistory={displayHistory}
            selectedClients={selectedClients}
            postAward={selectedClients && (selectedClients?.trackNowLicenseId === null || selectedClients?.trackNowLicenseId === 0) && (selectedClients?.postAwardLicenseId !== null || selectedClients?.postAwardLicenseId !== 0)}

          />
        </Paper>
      </Box>
      <ClientTableFilter
        anchorEl={filterAnchorEl}
        onClose={() => setFilterAnchorEl(null)}
        onApply={applyNewFilter}
        onClear={clearAllFilters}
        hasActiveFilters={activeFilters.length > 0 || (isFilterChange && isFilterChange.length > 0)}
        clients={clients}
        categoriesLookup={categoriesLookup}
        programList={programList}
        stateList={stateList}
        tracknowlicenseTypes={tracknowlicenseTypes}
        postawardlicenseTypes={postawardlicenseTypes}
        roleType={roleType}
        key={activeFilters.length}
      />
      {
        <SlidingDrawer
          show={showFilter}
          dockAt='right'
          handleClose={closeFilter}
        />
      }
      {/* {isLoading ? (
            <ReactLoading
              style={{
                position: "absolute",
                width: "10vw",
                height: "0vh",
                marginLeft: "36rem",
                marginTop: "10rem",
                color: "#0000FF",
              }}
              type='spin'
              color='blue'
            />
          ) : ( */}
      <style>{`
            .header-checkbox {
              color: white !important;
              background-color: ${tokens.colors.offWhite} !important;
            }
            .header-checkbox.Mui-checked {
              color: #432568 !important;
              background-color: ${tokens.colors.offWhite} !important;
            }
            .header-checkbox svg {
              fill: white;
            }
            .p-datatable.frozen-client-profile {
              border-radius: 8px !important;
              overflow: hidden !important;
              border: none !important;
              box-shadow: none !important;
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-wrapper {
              border-radius: 8px !important;
              overflow: hidden !important;
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-header {
              background: ${tokens.colors.offWhite} !important;
              border: none !important;
              padding: 0 !important;
              margin: 0 !important;
            }
            .frozen-client-profile .p-datatable-table {
              border-radius: 8px !important;
              border-collapse: separate !important;
              border-spacing: 0 !important;
            }
            .frozen-client-profile .p-datatable-thead > tr {
              background: ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-thead > tr > th.p-frozen-column {
              background: ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:last-child > td:first-child {
              border-bottom-left-radius: 8px !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:last-child > td:last-child {
              border-bottom-right-radius: 8px !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr {
              height: 45px !important;
            }
            .frozen-client-profile .p-datatable-emptymessage > td {
              height: 40px !important;
              padding: 10px 8px !important;
              line-height: 1.3 !important;
              font-size: 15px !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(odd) > td {
              background-color:  ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(even) > td {
              background-color: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-thead > tr > th {
              background: transparent !important;
              color: #ffffff !important;
              font-weight: 600 !important;
              font-size: 13px !important;
              letter-spacing: 0.02em !important;
              padding: 12px 16px !important;
              border-right: 1px solid rgba(255, 255, 255, 0.5) !important;
              border-bottom: none !important;
              text-transform: none !important;
              box-shadow: none !important;
            }
            .frozen-client-profile .p-datatable-thead > tr > th:last-child {
              border-right: none !important;
            }
            .frozen-client-profile .p-datatable-thead > tr > th.p-frozen-column {
              background: ${primaryColor} !important;
              z-index: 2 !important;
              will-change: auto !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
              color: #000000 !important;
              z-index: 1 !important;
              will-change: auto !important;
            }
            .frozen-client-profile .p-sortable-column-icon {
              color: #ffffff !important;
            }
            .frozen-client-profile .p-selection-column,
            .frozen-client-profile .p-datatable-tbody > tr > td.p-selection-column {
              text-align: center !important;
            }
            .frozen-client-profile .p-selection-column .p-radiobutton {
              margin: 0 auto !important;
              display: inline-flex !important;
            }
            .frozen-client-profile .p-selection-column .p-radiobutton .p-radiobutton-box {
              border: 2px solid ${primaryColor} !important;
            }
            .frozen-client-profile .p-selection-column .p-radiobutton .p-radiobutton-box.p-highlight {
              border-color: ${primaryColor} !important;
              background: ${primaryColor} !important;
            }
            .frozen-client-profile .p-selection-column .p-radiobutton:not(.p-radiobutton-disabled) .p-radiobutton-box:hover {
              border-color: ${primaryColor} !important;
            }
            .p-radiobutton .p-radiobutton-box.p-highlight {
              background: ${primaryColor} !important;
              border-color: ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr > td {
              background-color: ${tokens.colors.offWhite} !important;
              padding: 0 12px !important;
              font-size: 15px !important;
              line-height: 1.2 !important;
              color: #000000 !important;
              font-family: var(--tn-font-family) !important;
              overflow: hidden !important;
              text-overflow: ellipsis !important;
              white-space: nowrap !important;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
              border-left: none !important;
              border-top: none !important;
              vertical-align: middle !important;
              height: 45px !important;
              min-height: 45px !important;
              max-height: 45px !important;
              box-sizing: border-box !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(odd) > td {
              background-color: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(even) > td {
              background-color: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(odd) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:nth-child(even) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight):nth-child(odd) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
              color: #000000 !important;
              z-index: 1 !important;
              will-change: auto !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight):nth-child(even) > td.p-frozen-column {
              background: ${tokens.colors.offWhite} !important;
              color: #000000 !important;
              z-index: 1 !important;
              will-change: auto !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr > td:last-child {
              border-right: none !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight) > td.clientNameColumn-cp:hover,
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight) > td.expandableColumn-cp:hover {
              background-color: color-mix(in srgb, ${primaryColor} 8%, white) !important;
              cursor: pointer !important;
              transition: background-color 0.2s ease;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight) > td.clientNameColumn-cp:hover *,
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight) > td.expandableColumn-cp:hover * {
              font-weight: 600 !important;
              color: ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight) > td:not(.clientNameColumn-cp):not(.expandableColumn-cp):hover {
              background-color: inherit !important;
              font-weight: 400 !important;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr:not(.p-highlight) > td.indicatorsColumn:hover {
              background-color: ${tokens.colors.offWhite} !important;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.p-frozen-column,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn {
              background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight:hover,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight:hover > td,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td:hover,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.p-frozen-column:hover,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.clientNameColumn-cp:hover,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.expandableColumn-cp:hover,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn:hover {
              background-color: color-mix(in srgb, ${primaryColor} 14%, white) !important;
              border-right: 1px solid ${primaryColor} !important;
              border-bottom: 1px solid ${primaryColor} !important;
            }
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td:hover *,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.clientNameColumn-cp:hover *,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.expandableColumn-cp:hover *,
            .frozen-client-profile .p-datatable-tbody > tr.p-highlight > td.indicatorsColumn:hover * {
              font-weight: inherit !important;
            }
            .frozen-client-profile .p-column-filter-menu-button,
            .frozen-client-profile .p-column-filter-clear-button,
            .frozen-client-profile .p-column-filter-row {
              display: none !important;
            }
            .frozen-client-profile .p-datatable-loading-overlay {
              background: rgba(0, 0, 0, 0.35) !important;
              backdrop-filter: none !important;
              -webkit-backdrop-filter: none !important;
            }
            .frozen-client-profile .p-datatable-loading-icon {
              color: ${primaryColor} !important;
              font-size: 2rem !important;
              opacity: 0.95;
              text-rendering: geometricPrecision;
              -webkit-font-smoothing: antialiased;
            }
            .frozen-client-profile .p-datatable-loading-icon.pi-spin {
              animation-duration: 0.7s !important;
            }
            .p-datatable-wrapper::-webkit-scrollbar {
              width: 8px;
              height: 8px;
            }
            .p-datatable-wrapper::-webkit-scrollbar-thumb {
              background: #c0bec2;
              border-radius: 10px;
            }
            .p-datatable-wrapper::-webkit-scrollbar-thumb:hover {
              background: ${primaryColor};
            }
            .client-profile-expandable-cell {
              color: ${primaryColor};
            }
            .client-profile-more-count {
              color: ${primaryColor};
            }
            .client-profile-overlay-panel {
              z-index: 1100 !important;
              width: min(22rem, calc(100vw - 1rem)) !important;
              max-width: min(22rem, calc(100vw - 1rem)) !important;
              background: ${tokens.colors.offWhite} !important;
              border: 1px solid #C0BEC2 !important;
              overflow: hidden !important;
              box-sizing: border-box !important;
            }
            .client-profile-overlay-panel .p-overlaypanel-content {
              padding: 1.5rem 1rem 1rem 1rem !important;
              background: ${tokens.colors.offWhite} !important;
              max-width: 100% !important;
              box-sizing: border-box !important;
              overflow: hidden !important;
            }
            .client-profile-overlay-scroll::-webkit-scrollbar-thumb:hover {
              background: ${primaryColor};
            }
            .client-profile-overlay-panel .p-overlaypanel-close {
              background: ${primaryColor} !important;
              border: none !important;
              border-radius: 999px !important;
              width: 1.6rem !important;
              height: 1.6rem !important;
              color: #ffffff !important;
              position: absolute !important;
              top: 0.35rem !important;
              right: 0.35rem !important;
              margin: 0 !important;
              z-index: 2 !important;
              display: inline-flex !important;
              align-items: center !important;
              justify-content: center !important;
            }
            .client-profile-overlay-panel .p-overlaypanel-close:hover {
              background: ${primaryColor} !important;
              filter: brightness(1.08);
            }
            .client-profile-overlay-panel .p-overlaypanel-close .p-overlaypanel-close-icon {
              color: #ffffff !important;
            }
            .client-lookup-overlay-panel .p-overlaypanel-close {
              background: ${primaryColor} !important;
              border: 1px solid ${primaryColor} !important;
              border-radius: 999px !important;
            }
            .client-lookup-overlay-panel .p-overlaypanel-close,
            .client-lookup-overlay-panel .p-overlaypanel-close:hover {
              color: ${primaryColor} !important;
            }
            .client-lookup-overlay-panel .p-overlaypanel-close .p-overlaypanel-close-icon,
            .client-lookup-overlay-panel .p-overlaypanel-close .pi,
            .client-lookup-overlay-panel .p-overlaypanel-close svg {
              color: #ffffff !important;
              fill: #ffffff !important;
            }
          `}</style>
      <CustomDialog
        header={alertConfig.header}
        visible={showAlert}
        onHide={() => closeAlert()}
        icon={alertConfig.icon}
      >
        {alertMessage}
      </CustomDialog>
      <Dialog
        header='Confirmation'
        visible={showRadio}
        style={{ width: "30vw" }}
        onHide={() => radioCloseAlert()}
        footer={radioFooterContent}
      >
        <p className='m-0'>{radioMessage}</p>
        <FormControl>
          <RadioGroup
            aria-labelledby="demo-radio-buttons-group-label"
            name="radio-buttons-group"
            value={radioVal}
            onChange={handleRadioChange}
          >
            <FormControlLabel value="tracknow" control={<Radio />} label="Track Now" />
            <FormControlLabel value="postaward" control={<Radio />} label="Post Award" />

          </RadioGroup>
        </FormControl>
      </Dialog>
      {
        <CustomerComments
          show={showComments}
          dockAt='right'
          cust={selectedClients}
          comments={comments}
          handleClose={closeComments}
          refreshTable={tableRefresh}
        />
      }

      {
        <CustomerBusinessCategory
          show={showCategories}
          dockAt='right'
          cust={selectedClients}
          categories={categories}
          categoriesLookup={categoriesLookup}
          handleClose={closeCategories}
          refreshTable={tableRefresh}
        />
      }
      {
        <ClientProfileHistory
          show={showHistory}
          dockAt='right'
          tracker={selectedClients}
          activityHistory={activityHistory}
          commentActivityHistory={commentActivityHistory}
          handleClose={closeHistory}
        />
      }
    </Box >

  );
};

export default ClientProfiles;
